import { INPUT_COLOR_BORDER } from "../../utils/colors";

export const CONTENT_APPROVAL_SIDEBAR_WIDTH = 380;
export const CONTENT_APPROVAL_WORKSPACE_BG = "#e3e9ee";

export const contentApprovalLayoutRootSx = {
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  width: "100%",
  height: "100%",
  bgcolor: CONTENT_APPROVAL_WORKSPACE_BG,
};

export const contentApprovalMainSx = {
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
};

export const contentApprovalSidebarSx = {
  width: { xs: "100%", md: CONTENT_APPROVAL_SIDEBAR_WIDTH },
  minWidth: { md: CONTENT_APPROVAL_SIDEBAR_WIDTH },
  maxWidth: { md: CONTENT_APPROVAL_SIDEBAR_WIDTH },
  flexShrink: 0,
  borderLeft: { md: `1px solid ${INPUT_COLOR_BORDER}` },
  borderTop: { xs: `1px solid ${INPUT_COLOR_BORDER}`, md: "none" },
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  bgcolor: "background.paper",
};
